module.exports = __webpack_public_path__ + "static/img/cs_bg.aea5ff0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/connect_ecosoft_com/images/cs_bg.png
// module id = 1772
// module chunks = 0